import { Component, OnInit } from '@angular/core';
import { CookieXSRFStrategy } from '@angular/http';
import { Router } from '@angular/router';
import { AtbHomeService } from '../../services/atbHome.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'topnavbar',
  templateUrl: './topnavbar.component.html'

})

export class TopnavbarComponent implements OnInit {
  baseUrl;
  pathStructure;
  pathLogout
  constructor(private router: Router, private atbService: AtbHomeService) { }

  ngOnInit() {
    this.baseUrl = environment.baseUrl
    this.pathLogout = environment.restBaseUrl + 'logout';
  }

  goToAtbAtHome() {
    window.location.href = environment.restBaseRedirect + 'home';
  }



  Logout() {

   //this.goToAtbAtHome()
    this.atbService.logout(this.pathLogout).subscribe(
      (response) => {

      if (response.outcome.success === true) {
        this.goToAtbAtHome()
    } else {
      this.goToAtbAtHome()
    }

      },
      (error) => {
        this.goToAtbAtHome()
      }
      );
  }






}



// WEBPACK FOOTER //
// ./src/app/common/topnavbar/topnavbar.component.ts